// Add your JS customizations here
jQuery(document).ready(function($) {
	new WOW().init();


	let scroll;

	/**
	 * Adjust first section spacing based on nav height
	 * Must run BEFORE LocomotiveScroll measures layout
	 */
	function adjustFirstSectionSpacing() {
		let navHeight = $('.main-menu-desktop').hasClass('active')
			? 0
			: $('.desktop-nav').outerHeight();

		$('.first-section').css('padding-top', navHeight + 'px');
	}

	function adjustFooterSectionSpacing() {
		let navHeight = $('.main-menu-desktop').hasClass('active')
			? 0
			: $('.desktop-nav').outerHeight();

		$('.footer-section-spacer').css('padding-top', navHeight + 'px');
	}

	/**
	 * Initialise LocomotiveScroll AFTER layout is stable
	 */
	function initLocomotiveScroll() {

		if (
			document.body.classList.contains('single-project') ||
			!document.querySelector('[data-scroll-container]')
		) {
			scroll = null;
			return;
		}

		scroll = new LocomotiveScroll({
			el: document.querySelector('[data-scroll-container]'),
			smooth: true,
			direction: 'horizontal'
		});

		window.projectScroll = scroll;

		setTimeout(() => {

			if (!scroll || typeof scroll.update !== 'function') {
				return;
			}

			scroll.update();
			scroll.scrollTo(0, {
				duration: 0,
				disableLerp: true
			});

		}, 100);
	}

	/**
	 * Safe update helper
	 */
	function updateScroll() {
		if (scroll && typeof scroll.update === 'function') {
			scroll.update();
		}
	}

	/**
	 * INITIAL LOAD
	 * Wait for all assets (fonts/images) so measurements are correct
	 */
	 $(window).on('load', function() {

		 adjustFirstSectionSpacing();
		 adjustFooterSectionSpacing();

		 initLocomotiveScroll();
	 });

	/**
	 * RESIZE (debounced)
	 */
	let resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			adjustFirstSectionSpacing();
			adjustFooterSectionSpacing();
			updateScroll();
		}, 300);
	});

	/**
	 * MENU TOGGLE
	 */
	$('.main-menu-desktop-toggle').on('click', function() {
		adjustFirstSectionSpacing();
		adjustFooterSectionSpacing();
		updateScroll();
	});



	$('.hamburger').on('click', function () {
		$('.form-popout-form-trigger').toggleClass('active');
		$('.desktop-nav').toggleClass('active');
		$('.main-menu-desktop').toggleClass('active');
		$(this).toggleClass('is-active');

		if ($('.main-menu-desktop').hasClass('active')) {
			$('body').css('overflow', 'hidden');

			// ❌ Fully destroy Locomotive so menu scrolls normally
			if (window.projectScroll) {
				window.projectScroll.destroy();
				window.projectScroll = null;
			}
		} else {
			$('body').css('overflow', '');

			// ♻️ Re-init Locomotive when closing menu (only on those templates)
			if ($('body').is('.page-template-tmpl-home, .page-template-tmpl-about-us, .page-template-tmpl-brands')) {
				window.projectScroll = new LocomotiveScroll({
					el: document.querySelector('[data-scroll-container]'),
					smooth: true,
					direction: 'horizontal'
				});
			}
		}
	});

	// Pop-out Section Trigger - Contact Form & Closes Nav Menu
	$('.form-popout-form-trigger').on('click', function () {
		$('.contact-form').addClass('form-active');
		$('.contact-form-overlay').addClass('overlay-active');

		// Close menu state
		$('.form-popout-form-trigger').removeClass('active');
		$('.desktop-nav').removeClass('active');
		$('.main-menu-desktop').removeClass('active');
		$('.hamburger').removeClass('is-active');

		// Lock scroll
		$('body').css('overflow', 'hidden');

		// ❌ Destroy Locomotive
		if (window.projectScroll) {
			window.projectScroll.destroy();
			window.projectScroll = null;
		}
	});

	// Pop-out Section Trigger if error
	if ($('#gform_wrapper_1').hasClass('gform_validation_error')) {

		$('.contact-form').addClass('form-active');
		$('.contact-form-overlay').addClass('overlay-active');

		// Close menu state
		$('.form-popout-form-trigger').removeClass('active');
		$('.desktop-nav').removeClass('active');
		$('.main-menu-desktop').removeClass('active');
		$('.hamburger').removeClass('is-active');

		// Lock scroll
		$('body').css('overflow', 'hidden');

		// Destroy Locomotive
		if (window.projectScroll) {
			window.projectScroll.destroy();
			window.projectScroll = null;
		}
	}

	// Pop-out Section Close Trigger - Contact Form
	$('.contact-form .close-icon, .contact-form-overlay').on('click', function () {
		$('.contact-form').removeClass('form-active');
		$('.contact-form-overlay').removeClass('overlay-active');

		// Unlock scroll
		$('body').css('overflow', '');

		// ♻️ Re-init Locomotive (same templates as hamburger)
		if (
			$('body').is(
				'.page-template-tmpl-home, .page-template-tmpl-about-us, .page-template-tmpl-brands'
			)
		) {
			window.projectScroll = new LocomotiveScroll({
				el: document.querySelector('[data-scroll-container]'),
				smooth: true,
				direction: 'horizontal'
			});
		}
	});



	// Pop-out Section Trigger - Home Page
	$('.popout-section-trigger').on('click', function() {
		$('.popout-section').addClass('active');
		$(this).addClass('hidden');
	});

	// Pop-out Section Close Trigger - Home Page
	$('.popout-close-trigger').on('click', function() {
		$('.popout-section').removeClass('active');
		$('.popout-section-trigger').removeClass('hidden');
	});

	// Single Project Slider
	$('.single-project-slider').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		// Set initial slide index
		var i = (currentSlide ? currentSlide : 0) + 1;
		$('.current-slide').text(i);
	});

	$('.single-project-slider').slick({
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: true,
		slidesToShow: 1,
		adaptiveHeight: false,
		arrows: true,
		dots: false,
		infinite: true,
		centerMode: false,
		prevArrow: $('.project-prev'),
		nextArrow: $('.project-next')
	});

	// Pop-out Section Trigger - Home Page
	$('.single-project-popout-trigger').on('click', function() {
		$('.single-project-popout-content').addClass('active');
		$(this).addClass('hidden');
		$('body').css('overflow', 'hidden'); // Prevent scrolling
	});

	// Pop-out Section Close Trigger - Home Page
	$('.single-project-popout-close').on('click', function() {
		$('.single-project-popout-content').removeClass('active');
		$('.single-project-popout-trigger').removeClass('hidden');
		$('body').css('overflow', ''); // Restore scrolling
	});

	// Newsletter Popup Trigger
	$('.newsletter-popup-trigger').on('click', function(e) {
		e.preventDefault(); // Prevent link navigation
		$('.newsletter-popup-wrapper').addClass('active');
		$('body').css('overflow', 'hidden'); // Disable page scroll
	});

	// Newsletter Popup Close
	$('.newsletter-popout-close').on('click', function() {
		$('.newsletter-popup-wrapper').removeClass('active');
		$('body').css('overflow', ''); // Re-enable scroll
	});

	// Project Filtering and Grids
	var $grid = $('.project-grid').isotope({
		itemSelector: '.grid-item',
		layoutMode: 'masonry',
	});

	$('.filter-button').on('click', function(e) {
		e.preventDefault();

		var filterValue = $(this).attr('data-filter');
		$grid.isotope({ filter: filterValue });

		$('.filter-button').removeClass('active');
		$(this).addClass('active');

		adjustFirstSectionSpacing();

		var navHeight = $('.desktop-nav').outerHeight() || 0;
		var scrollTo = $('.project-grid').offset().top - navHeight - 23;

		$('html, body').animate({
			scrollTop: scrollTo
		}, 600);
	});

	$('.brands-slider').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 15000,
		cssEase: 'linear',
		pauseOnHover: false,
		pauseOnFocus: false,
		centerMode: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: { slidesToShow: 4 }
			},
			{
				breakpoint: 768,
				settings: { slidesToShow: 3 }
			},
			{
				breakpoint: 480,
				settings: { slidesToShow: 2 }
			}
		]
	});

	$('.location-slider-1').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: true
	});

	$('.location-slider-2').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: true
	});

	// Site Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('.popup-wrapper').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('.popup-wrapper').removeClass('active');
		// Set session cookie (no expiry = removed on browser close)
		setCookie('ctaPopupDismissed', 'true');
	});



	$(document).on('click', '#gform_1 .custom-submit', function() {

		var $button = $(this);
		var $submitting = $button.next('.gravity-form-submitting');

		$button.hide();
		$submitting.show();

	});

	$(document).on('click', '#gform_5 .custom-submit', function() {

		var $button = $(this);
		var $submitting = $button.next('.gravity-form-submitting');

		$button.hide();
		$submitting.show();

	});

	$(document).on('gform_post_render', function(event, formId) {

		if (formId == 1) {

			var $form = $('#gform_1');
			var $button = $form.find('.custom-submit');
			var $submitting = $form.find('.gravity-form-submitting');

			$button.show();
			$submitting.hide();

		}

		if (formId == 5) {

			var $form = $('#gform_5');
			var $button = $form.find('.custom-submit');
			var $submitting = $form.find('.gravity-form-submitting');

			$button.show();
			$submitting.hide();

		}

	});

	$('.image_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: false,
		prevArrow: $('.ic_prev'),
		nextArrow: $('.ic_next'),
	});

	$('.desktop_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 8000,
		adaptiveHeight: false,
		prevArrow: $('.dc_prev'),
		nextArrow: $('.dc_next'),
	});

	$('.mobile_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 8000,
		adaptiveHeight: false,
		prevArrow: $('.mc_prev'),
		nextArrow: $('.mc_next'),
	});

	$('.project_carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				},
			}
		]
	});

});